import React from 'react';

const StatusBadge = ({ status }) => {
  const statusConfig = {
    cotizada: {
      label: 'Cotizada',
      className: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300'
    },
    aprobada: {
      label: 'Aprobada',
      className: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300'
    },
    en_proceso: {
      label: 'En proceso',
      className: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300'
    },
    lista: {
      label: 'Lista',
      className: 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300'
    },
    entregada: {
      label: 'Entregada',
      className: 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-300'
    },
    cancelada: {
      label: 'Cancelada',
      className: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300'
    }
  };

  const config = statusConfig?.[status] || statusConfig?.cotizada;

  return (
    <span className={`inline-flex items-center px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-medium ${config?.className}`}>
      {config?.label}
    </span>
  );
};

export default StatusBadge;